import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    url: 'default/login',
    method: 'post',
    data
  })
}

export function RequestCode (data) {
  return request({
    url: 'default/send-code',
    method: 'post',
    data
  })
}

export function ActiveAccount (data) {
  return request({
    url: 'default/active',
    method: 'post',
    data
  })
}

export function ResetPassword (data) {
  return request({
    url: 'default/reset-password',
    method: 'post',
    data
  })
}
